export default __webpack_public_path__ + "static/media/large.15bb0c6c.jpg";